export const consts = {
    F8: 'F8',
    ESC: 'Esc'
};

export const actionsToMonitor = ['FollowupUser', 'CopyRecordLink'];

export const EXIT_FORM = 'exit-form';
export const CHANGE_IS_PAINTED = 'change-is-painted';
